var TECL_Wishlist = {
  CurrentProductId: "",
  CurrentWishlistId: "",
  CurrentUmbracoNodeId: "",
  WishlistTerminology: "wishlist",
  Initialise: function() {
    $( document ).ready( function() {
      var wishlistTerminology = $( "#wishlistTerminology" ).val();
      if ( wishlistTerminology ) {
        TECL_Wishlist.WishlistTerminology = wishlistTerminology;
        $( ".wishlistTerm" ).text( wishlistTerminology );
      }

      $( "#wishlistsSort" ).val( TECL_Master.GetParameterByName( "orderBy" ) );
      TECL_Wishlist.CurrentUmbracoNodeId = $( "#currentUmbracoNodeId" ).val();

      $( document ).on( "click", ".add-to-wishlist", function( e ) {
        TECL_Wishlist.OpenAddToWishlistModal( e );
      } );

      $( document ).on( "click", ".create-new-wishlist", function( e ) {
        TECL_Wishlist.OpenCreateNewWishlistModal( e );
      } );

      $( document ).on( "click", ".delete-wishlist", function( e ) {
        TECL_Wishlist.OpenDeleteWishlistModal( e );
      } );

      $( document ).on( "click", ".rename-wishlist", function( e ) {
        TECL_Wishlist.OpenRenameWishlistModal( e );
      } );

      $( document ).on( "click", ".copy-wishlist", function( e ) {
        TECL_Wishlist.OpenCopyWishlistModal( e );
      } );

      $( document ).on( "click", ".save-wishlist", function( e ) {
        TECL_Wishlist.OpenSaveWishlistModal( e );
      } );

      $( document ).on( "click", ".email-wishlist", function( e ) {
        TECL_Wishlist.OpenEmailWishlistModal( e );
      } );

      $( document ).on( "click", ".convert-wishlist", function( e ) {
        TECL_Wishlist.OpenConvertWishlistToBasketModal( e );
      } );

      $( document ).on( "click", ".convert-basket", function( e ) {
        TECL_Wishlist.OpenConvertBasketToWishlistModal( e );
      } );

      $( document ).on( "click", ".submit-add-to-wishlist", function( e ) {
        TECL_Wishlist.AddProductToWishlists( e );
      } );

      $( document ).on( "click", ".submit-delete-wishlist", function( e ) {
        TECL_Wishlist.DeleteWishlist( e );
      } );

      $( document ).on( "click", ".submit-new-wishlist", function( e ) {
        TECL_Wishlist.CreateNewWishlist( e );
      } );

      $( document ).on( "click", ".submit-rename-wishlist", function( e ) {
        TECL_Wishlist.RenameWishlist( e );
      } );

      $( document ).on( "click", ".submit-copy-wishlist", function( e ) {
        TECL_Wishlist.CopyWishlist( e );
      } );

      $( document ).on( "click", ".submit-save-wishlist", function( e ) {
        TECL_Wishlist.SaveWishlist( e );
      } );

      $( document ).on( "click", ".submit-email-wishlist", function( e ) {
        TECL_Wishlist.EmailWishlist( e );
      } );

      $( document ).on( "click", ".submit-convert-wishlist", function( e ) {
        TECL_Wishlist.ConvertWishlistToBasket( e );
      } );

      $( document ).on( "click", ".submit-convert-basket", function( e ) {
        TECL_Wishlist.ConvertBasketToWishlist( e );
      } );

      $( document ).on( "change", ".wishlist-item-input", function( e ) {
        TECL_Wishlist.EnableOrDisableAddToListsButton( e );
      } );

      $( document ).on( "click", ".update-wishlist-product-quantity", function( e ) {
        TECL_Wishlist.UpdateProductQuantity( e );
      } );

      $( document ).on( "click", ".remove-wishlist-product", function( e ) {
        TECL_Wishlist.RemoveProduct( e );
      } );

      $( "#createNewWishlistModal" ).on( "hidden.bs.modal", function ( e ) {
        TECL_Wishlist.FixNestedModalScrollbar( e );
      } );

      $( document ).on( "change", "#wishlistsSort", function( e ) {
        TECL_Wishlist.SortMyWishlists( e );
      } );

      $( document ).on( "change", "#wishlistSort", function( e ) {
        TECL_Wishlist.SortWishlist( e );
      } );
    } );
  },
  SortWishlist: function( e ) {
    var currentSort = TECL_Master.GetParameterByName( "orderBy" );
    var value = $( e.target ).val();
    if ( value && currentSort !== value ) {
      window.location.href = TECL_Filter.UpdateQueryString( "orderBy", value );
    }
  },
  SortMyWishlists: function( e ) {
    var currentSort = TECL_Master.GetParameterByName( "orderBy" );
    var value = $( e.target ).val();
    if ( value && currentSort !== value ) {
      window.location.href = TECL_Filter.UpdateQueryString( "orderBy", value );
    }
  },
  FixNestedModalScrollbar: function() {
    if ( ( $( "#addToWishlistsModal" ).data( "bs.modal" ) || {} ).isShown ) {
      $( "body" ).addClass( "modal-open" );
    }
  },
  OpenAddToWishlistModal: function( e ) {
    var element = $( e.target );
    var productId = TECL_Wishlist.GetElementDataAttribute( element, "data-product-id" );

    TECL_Wishlist.CurrentProductId = productId;
    TECL_Wishlist.UpdateWishlistList();
    $( "#addToWishlistsModal" ).modal( "show" );   
  },
  OpenCreateNewWishlistModal: function( e ) {
    $( "#createNewWishlistModal" ).modal( "show" );
  },
  OpenDeleteWishlistModal: function( e ) {
    var element = $( e.target );
    var wishlistId = TECL_Wishlist.GetElementDataAttribute( element, "data-wishlist-id" );

    TECL_Wishlist.CurrentWishlistId = wishlistId;

    $( "#deleteWishlistModal" ).modal( "show" );
  },
  OpenRenameWishlistModal: function( e ) {
    var element = $( e.target );
    var wishlistId = TECL_Wishlist.GetElementDataAttribute( element, "data-wishlist-id" );

    TECL_Wishlist.CurrentWishlistId = wishlistId;
    $( "#renameWishlistModal" ).modal( "show" );
  },
  OpenEmailWishlistModal: function( e ) {
    var element = $( e.target );
    var wishlistId = TECL_Wishlist.GetElementDataAttribute( element, "data-wishlist-id" );

    TECL_Wishlist.CurrentWishlistId = wishlistId;

    $( "#emailWishlistModal" ).modal( "show" );
  },
  OpenCopyWishlistModal: function( e ) {
    var element = $( e.target );
    var wishlistId = TECL_Wishlist.GetElementDataAttribute( element, "data-wishlist-id" );

    TECL_Wishlist.CurrentWishlistId = wishlistId;

    $( "#copyWishlistModal" ).modal( "show" );
  },
  OpenSaveWishlistModal: function( e ) {
    var element = $( e.target );
    var wishlistId = TECL_Wishlist.GetElementDataAttribute( element, "data-wishlist-id" );

    TECL_Wishlist.CurrentWishlistId = wishlistId;

    $( "#saveWishlistModal" ).modal( "show" );
  },
  OpenConvertWishlistToBasketModal: function( e ) {
    var element = $( e.target );
    var wishlistId = TECL_Wishlist.GetElementDataAttribute( element, "data-wishlist-id" );

    TECL_Wishlist.CurrentWishlistId = wishlistId;

    $( "#convertWishlistToBasketModal" ).modal( "show" );
  },
  OpenConvertBasketToWishlistModal: function( e ) {
    $( "#convertBasketToWishlistModal" ).modal( "show" );
  },
  GetElementDataAttribute: function( element, attribute ) {
    if ( !element.attr( attribute ) ) {
      var childElements = element.find( "[" + attribute + "]" );
      var parentElements = element.closest( "[" + attribute + "]" );
      
      if ( childElements.length > 0 ) {
        element = childElements.first();
      }

      if ( parentElements.length > 0 ) {
        element = parentElements.first();
      }
    }

    return element.attr( attribute );
  },
  EnableOrDisableAddToListsButton: function() {
    var wishlistIds = [];

    $( "#wishlistsList" ).find( ":checked" ).each( function ( i, element ) {
      wishlistIds.push( $( element ).val() );
    } );

    if ( wishlistIds.length > 0 ) {
      $( ".submit-add-to-wishlist" ).removeAttr( "disabled" );
    } else {
      $( ".submit-add-to-wishlist" ).attr( "disabled", true );
    }
  },
  ShowErrorModal: function( modalToHide, message ) {
    $( modalToHide ).modal( "hide" );
    $( "#errorModal" ).modal( "show" );
    $( "#errorModal" ).find( ".modal-body p" ).text( message );
  },
  ShowSuccessModal: function( modalToHide, message, actionUrl, hideCancelButton ) {
    if ( hideCancelButton === false ) {
      $( "#wishlistSuccessModalCancel" ).hide();
    } else {
      $( "#wishlistSuccessModalCancel" ).show();
    }

    $( modalToHide ).modal( "hide" );
    $( "#wishlistSuccessModal" ).modal( "show" );
    $( "#wishlistSuccessModal" ).find( ".modal-body p" ).text( message );
    $( "#wishlistSuccessModalAction" ).attr( "href", actionUrl );
  },
  ShowAddedToWishlist: function( productId ) {
    var element = $( ".add-to-wishlist[data-product-id='" + productId + "']" );
    var addedSnippet = "<span id=\"added_{productId}\" style=\"float: left; display: none\">" +
                       "<i class=\"fa fa-check\" aria-hidden=\"true\"></i> Added" +
                       "</span>";

    if ( element.length > 0 ) {
      var clickedButtonHtml = element.html();
      element.html( addedSnippet );

      element.find( "span" ).fadeIn( 500 ).delay( 1000 ).fadeOut( 500, function () {
        element.removeAttr( "disabled" );
        this.remove();
        element.html( clickedButtonHtml );
      } );
    }
  },
  UpdateWishlistList: function( selectedWishlist ) {
    if ( $( "#activeTab" ).length > 0 ) {
      window.location.reload();
    }

    $.ajax( {
      url: "/umbraco/Surface/WishlistsSurface/Index",
      type: "POST",
      data: {
        orderBy: ""
      },
      success: function ( data ) {
        if ( data.Error !== undefined ) {
          alert( data.Error );
        } else {
          var wishlistCount = 0;
          var wishlistList = $( "#wishlistsList" );

          if ( wishlistList && data.wishlists != null ) {
            wishlistCount = data.wishlists.length;
            wishlistList.empty();

            $.each( data.wishlists, function ( index, value ) {
              var checkedString = "";
              if ( value.Id === selectedWishlist ) {
                checkedString = "checked ";
              } else if ( wishlistCount === 1 ) {
                checkedString = "checked ";
              }

              var element = '<div class="wishlist-item">' +
                            '<label for="addToWishlist_' + value.Id +'">' +
                            '<input type="checkbox" id="addToWishlist_' + value.Id + '"' +
                            'value="' + value.Id + '"' + checkedString +
                            'class="wishlist-item-input"> ' +
                            value.Title +
                            '</label></div>';

              wishlistList.append( element );
            } );

            if ( wishlistCount == 0 ) {
              wishlistList.append( 
                '<div class="no-wishlists">' +
                'You don\'t have any ' + TECL_Wishlist.WishlistTerminology  + 's. ' +
                'Why not <a class="create-new-wishlist" href="#">create one</a>?' +
                '</div>'
              );
            }
          }

          TECL_Wishlist.EnableOrDisableAddToListsButton();
        }
      }
    } );
  },
  AddProductToWishlists: function() {
    var productId = TECL_Wishlist.CurrentProductId;
    var wishlistIds = [];

    $( "#wishlistsList" ).find( ":checked" ).each( function ( i, element ) {
      wishlistIds.push( $( element ).val() );
    } );

    var quantity = $( "#qty_" + productId ).val() || "1";

    $.ajax( {
      url: "/umbraco/Surface/WishlistsSurface/AddProduct",
      type: "POST",
      data: {
        wishlistIds: wishlistIds,
        productId: productId,
        quantity: parseInt( quantity ),
      },
      success: function ( data ) {
        if ( !data.success ) {
          TECL_Wishlist.ShowErrorModal( 
            "#addToWishlistsModal", 
            "There was an error adding this product. Please try again later."
          );
        } else {
          TECL_Wishlist.UpdateWishlistList();
          TECL_Wishlist.ShowAddedToWishlist( productId );
          $( "#addToWishlistsModal" ).modal( "hide" );
        }
      }
    } );
  },
  DeleteWishlist: function() {
    $.ajax( {
      url: "/umbraco/Surface/WishlistsSurface/Delete",
      type: "POST",
      data: {
        id: TECL_Wishlist.CurrentWishlistId
      },
      success: function ( data ) {
        if ( !data.success ) {
          TECL_Wishlist.ShowErrorModal( 
            "#deleteWishlistModal",
            "There was an error deleting this " + TECL_Wishlist.WishlistTerminology + ". Please try again later."
          );
        } else {
          window.location.href = "/web-account?tab=myWishlists";
          TECL_Wishlist.UpdateWishlistList();
        }
      }
    } );
  },
  CreateNewWishlist: function() {
    var wishlistName = $( "#newWishListName" ).val();

    if ( wishlistName ) {
      $( "#newWishListName" ).next( ".field-validation-error" ).remove();
      $( "#newWishListName" ).val( "" );

      $.ajax( {
        url: "/umbraco/Surface/WishlistsSurface/Create",
        type: "POST",
        data: {
          wishlistName: wishlistName
        },
        success: function ( data ) {
          if ( !data.success ) {
            TECL_Wishlist.ShowErrorModal( 
              "#createNewWishlistModal",
              "There was an error creating a new " + TECL_Wishlist.WishlistTerminology + ". Please try again later."
            );
          } else {
            TECL_Wishlist.UpdateWishlistList( data.wishlist.Id );
            $( "#createNewWishlistModal" ).modal( "hide" );
          }
        }
      } );
    } else {
      $( "#newWishListName" ).after( '<p class="field-validation-error">This field is required.</p>' );
    }
  },
  RenameWishlist: function() {
    var wishlistName = $( "#renameWishListName" ).val();

    if ( wishlistName ) {
      $( "#renameWishListName" ).next( ".field-validation-error" ).remove();
      $( "#renameWishListName" ).val( "" );

      $.ajax( {
        url: "/umbraco/Surface/WishlistsSurface/Rename",
        type: "POST",
        data: {
          id: TECL_Wishlist.CurrentWishlistId,
          wishlistName: wishlistName
        },
        success: function ( data ) {
          if ( !data.success ) {
            TECL_Wishlist.ShowErrorModal( 
              "#renameWishlistModal", 
              "There was an error renaming this " + TECL_Wishlist.WishlistTerminology + ". Please try again later."
            );
          } else {
            $( "#wishlistName" ).text( wishlistName );
            $( "#renameWishlistModal" ).modal( "hide" );
          }
        }
      } );
    } else {
      $( "#renameWishListName" ).after( '<p class="field-validation-error">This field is required.</p>' );
    }
  },
  CopyWishlist: function () {
    var wishlistName = $( "#copyWishListName" ).val();

    if ( wishlistName ) {
      $( "#copyWishListName" ).next( ".field-validation-error" ).remove();
      $( "#copyWishListName" ).val( "" );

      $.ajax( {
        url: "/umbraco/Surface/WishlistsSurface/Copy",
        type: "POST",
        data: {
          id: TECL_Wishlist.CurrentWishlistId,
          newWishlistName: wishlistName
        },
        success: function ( data ) {
          if ( !data.success ) {
            TECL_Wishlist.ShowErrorModal( 
              "#copyWishlistModal", 
              "There was an error copying this " + TECL_Wishlist.WishlistTerminology + ". Please try again later."
            );
          } else {
            TECL_Wishlist.ShowSuccessModal(
              "#copyWishlistModal",
              "Your " + TECL_Wishlist.WishlistTerminology + " was copied successfully. " +
              "Click Continue to be taken to your new " + TECL_Wishlist.WishlistTerminology + 
              ", or cancel to remain on the current " + TECL_Wishlist.WishlistTerminology + ".",
              "/wishlists/?id=" + data.wishlist.Id
            );
          }
        }
      } );
    } else {
      $( "#copyWishListName" ).after( '<p class="field-validation-error">This field is required.</p>' );
    }
  },
  SaveWishlist: function () {
    var wishlistName = $( "#saveWishListName" ).val();

    if ( wishlistName ) {
      $( "#saveWishListName" ).next( ".field-validation-error" ).remove();
      $( "#saveWishListName" ).val( "" );

      $.ajax( {
        url: "/umbraco/Surface/WishlistsSurface/Copy",
        type: "POST",
        data: {
          id: TECL_Wishlist.CurrentWishlistId,
          newWishlistName: wishlistName
        },
        success: function ( data ) {
          if ( !data.success ) {
            TECL_Wishlist.ShowErrorModal( 
              "#saveWishlistModal",
              "There was an error saving this " + TECL_Wishlist.WishlistTerminology +". Please try again later."
            );
          } else {
            TECL_Wishlist.ShowSuccessModal(
              "#saveWishlistModal",
              "Your " + TECL_Wishlist.WishlistTerminology + " was saved successfully. " + 
              "Click Continue to be taken to your new " + TECL_Wishlist.WishlistTerminology + 
              ", or cancel to remain on the current " + TECL_Wishlist.WishlistTerminology + ".",
              "/wishlists/?id=" + data.wishlist.Id
            );
          }
        }
      } );
    } else {
      $( "#saveWishListName" ).after( '<p class="field-validation-error">This field is required.</p>' );
    }
  },
  EmailWishlist: function () {
    var recipient = $( "#emailWishListRecipient" ).val();
    var message = $( "#emailWishListMessage" ).val();
    $("#emailWishListRecipient").next(".field-validation-error").remove();

    if ( recipient && TECL_Master.IsEmailAddress( recipient ) ) {
      $( "#emailWishListRecipient" ).val( "" );
      $( "#emailWishListMessage" ).val( "" );

      $( ".submit-email-wishlist" ).attr( "disabled", true );
      $( ".submit-email-wishlist" ).text( "Sending..." );

      $.ajax( {
        url: "/umbraco/Surface/WishlistsSurface/Email",
        type: "POST",
        data: {
          id: TECL_Wishlist.CurrentWishlistId,
          recipientEmailAddress: recipient,
          message: message,
          nodeId: TECL_Wishlist.CurrentUmbracoNodeId
        },
        success: function ( data ) {
          $( ".submit-email-wishlist" ).removeAttr( "disabled" );
          $( ".submit-email-wishlist" ).text( "Send" );

          if ( !data.success ) {
            TECL_Wishlist.ShowErrorModal(
              "#emailWishlistModal", 
              "There was an error emailing this " + TECL_Wishlist.WishlistTerminology + ". Please try again later."
            );
          } else {
            TECL_Wishlist.ShowSuccessModal(
              "#emailWishlistModal",
              "Your " + TECL_Wishlist.WishlistTerminology + " was emailed successfully.",
              "/wishlists/?id=" + TECL_Wishlist.CurrentWishlistId,
              false
            );
          }
        }
      } );
    } else {
      if ( !recipient ) {
        $( "#emailWishListRecipient" ).after( '<p class="field-validation-error">This field is required.</p>' );
      } else {
        $( "#emailWishListRecipient" ).after( '<p class="field-validation-error">Please enter a valid email address.</p>' );
      }
    }
  },
  ConvertWishlistToBasket: function () {
    $.ajax( {
      url: "/umbraco/Surface/WishlistsSurface/ConvertToBasket",
      type: "POST",
      data: {
        id: TECL_Wishlist.CurrentWishlistId
      },
      success: function ( data ) {
        if ( !data.success ) {
          TECL_Wishlist.ShowErrorModal(
            "#convertWishlistToBasketModal", 
            "There was an error converting this " + TECL_Wishlist.WishlistTerminology + ". Please try again later."
          );
        } else {
          TECL_Wishlist.ShowSuccessModal(
            "#convertWishlistToBasketModal",
            "Your " + TECL_Wishlist.WishlistTerminology + " was converted successfully. " +
            "Click Continue to be taken to your basket, or cancel to remain on the current " + 
            TECL_Wishlist.WishlistTerminology + ".",
            "/basket"
          );
        }
      }
    } );
  },
  ConvertBasketToWishlist: function () {
    var wishlistName = $( "#convertWishListName" ).val();

    if ( wishlistName ) {
      $( "#convertWishListName" ).next( ".field-validation-error" ).remove();
      $( "#convertWishListName" ).val( "" );

      $.ajax( {
        url: "/umbraco/Surface/WishlistsSurface/ConvertFromBasket",
        type: "POST",
        data: {
          wishlistName: wishlistName
        },
        success: function ( data ) {
          if ( !data.success ) {
            TECL_Wishlist.ShowErrorModal( 
              "#convertBasketToWishlistModal", 
              "There was an error converting your basket. Please try again later."
            );
          } else {
            TECL_Wishlist.ShowSuccessModal(
              "#convertBasketToWishlistModal",
              "Your basket was converted successfully. Click Continue to be taken to your new " +
              TECL_Wishlist.WishlistTerminology + ", or cancel to remain on your basket.",
              "/wishlists?id=" + data.wishlist.Id
            );
          }
        }
      } );
    } else {
      $( "#convertWishListName" ).after( '<p class="field-validation-error">This field is required.</p>' );
    }
  },
  UpdateProductQuantity: function( e ) {
    var element = $( e.target );
    var productId = TECL_Wishlist.GetElementDataAttribute( element, "data-product-id" );
    var wishlistId = TECL_Wishlist.GetElementDataAttribute( element, "data-wishlist-id" );

    var wishlistIds = [];
    wishlistIds.push( wishlistId );

    var quantity = $( "#quantity_" + productId ).val();
    
    $.ajax( {
      url: "/umbraco/Surface/WishlistsSurface/UpdateProductQuantity",
      type: "POST",
      data: {
        wishlistIds: wishlistIds,
        productId: productId,
        quantity: quantity
      },
      success: function ( data ) {
        if ( !data.success ) {
          TECL_Wishlist.ShowErrorModal( 
            null,
            "There was an error updating this product quantity. Please try again later."
          );
        } else {
          window.location.reload();
        }
      }
    } );
  },
  RemoveProduct: function( e ) {
    var element = $( e.target );
    var productId = TECL_Wishlist.GetElementDataAttribute( element, "data-product-id" );
    var wishlistId = TECL_Wishlist.GetElementDataAttribute( element, "data-wishlist-id" );

    var wishlistIds = [];
    wishlistIds.push( wishlistId );
    
    $.ajax( {
      url: "/umbraco/Surface/WishlistsSurface/RemoveProduct",
      type: "POST",
      data: {
        wishlistIds: wishlistIds,
        productId: productId
      },
      success: function ( data ) {
        if ( !data.success ) {
          TECL_Wishlist.ShowErrorModal( 
            null,
            "There was an error removing this product. Please try again later."
          );
        } else {
          window.location.reload();
        }
      }
    } );
  }
}